export enum TaskType {
    CONTENT = "CONTENT",
    CODE = "CODE",
    ACTIVITY_CODE = "ACTIVITY_CODE",
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    INSTRUCTION = "INSTRUCTION",
    INSTRUCTION_MULTIPLE_CHOICE = "INSTRUCTION_MULTIPLE_CHOICE",
    MULTI_FILE_CODE = "MULTI_FILE_CODE",
    SHORT_QA = "SHORT_QA",
    INSTRUCTION_SHORT_QA = "INSTRUCTION_SHORT_QA",
    EMBED = "EMBED",
    CODE_WITHOUT_RUN ="CODE_WITHOUT_RUN",
    DESCRIPTIVE_QA = "DESCRIPTIVE_QA",
    INSTRUCTION_DESCRIPTIVE_QA = "INSTRUCTION_DESCRIPTIVE_QA"
}

export enum TaskPoint {
    CONTENT = "50",
    CODE = "100",
    ACTIVITY_CODE = "100",
    MULTIPLE_CHOICE = "70",
    INSTRUCTION = "100",
    INSTRUCTION_MULTIPLE_CHOICE = "100",
    MULTI_FILE_CODE = "100",
    SHORT_QA = "100",
    INSTRUCTION_SHORT_QA = "100",
    DESCRIPTIVE_QA = "100",
    INSTRUCTION_DESCRIPTIVE_QA = "100"
}
